import PropTypes from 'prop-types';
import React from 'react';
import { cellPropsType } from '../../workQueue.constant';

const MedicationAssociationInsuranceCell = ({ value }) => {
    if (value !== '--') {
        return <span>{value.length > 0 ? value.join(', ') : '--'}</span>;
    }
    return <span>{value}</span>;
};

MedicationAssociationInsuranceCell.propTypes = {
    ...cellPropsType,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.arrayOf(PropTypes.string)]),
};

MedicationAssociationInsuranceCell.defaultProps = {
    value: '--',
};

export default MedicationAssociationInsuranceCell;
